/* eslint-disable import/prefer-default-export */
import { useEffect } from 'react';

import { useLazyQuery, useMutation } from 'react-apollo';
import { GET_UNSEEN_MESSAGES, GET_ACTIVE_ARTIST } from '../graphql-client/queries';
import { UNSEEN_MESSAGES_MUTATION } from '../graphql-client/mutations';
import {
  CHAT_CONSTANTS, getLocalUserData, staticConstants,
} from '.';
import { myFirestore, fieldPath } from '../config/firebase';

export const useChatMessageInitializer = () => {
  const [activeArtistQuery, { data: activeArtistData }] = useLazyQuery(GET_ACTIVE_ARTIST);
  const userData = getLocalUserData();

  const [updateUnseenMessage] = useMutation(UNSEEN_MESSAGES_MUTATION,
    {
      variables: {},
      refetchQueries: [{ query: GET_UNSEEN_MESSAGES }],
    });

  const getConversations = (userId) => {
    myFirestore
      .collection(`${CHAT_CONSTANTS.USERS}`).doc(userId).get().then((messages) => {
        if (messages && messages.data()) {
          updateUnseenMessage({ variables: { unseenMessages: Object.values(messages.data()) } });
        }
      });
  };

  const markConversationAsRead = async (chatRooms, userId) => {
    const coversationData = await myFirestore
      .collection(`${CHAT_CONSTANTS.USERS}`).doc(userId).get();

    chatRooms.map(async (el) => {
      coversationData.data() && Object.prototype.hasOwnProperty.call(coversationData.data(), el._id)
      && await myFirestore
        .collection(`${CHAT_CONSTANTS.USERS}`).doc(userId).set({ [el._id]: { unseenMessage: false } }, { merge: true });
    });
    getConversations(userId);
  };

  const getMessages = async (chatRooms, userId) => {
    const data = await myFirestore
      .collection(`${CHAT_CONSTANTS.MESSAGE_BOARD}`).where(fieldPath.documentId(), 'in', chatRooms.map((el) => el._id))
      .get();
    markConversationAsRead(chatRooms, userId);
    return data;
  };

  const onNewChatMessage = (userId) => {
    myFirestore
      .collection(`${CHAT_CONSTANTS.USERS}`).doc(userId).onSnapshot((messages) => {
        if (messages && messages.data()) {
          getConversations(userId);
        }
      });
  };

  useEffect(() => {
    [staticConstants.ROLE.ARTIST, staticConstants.ROLE.SYSTEM_ADMIN].indexOf(userData.role) > -1 && (() => {
      onNewChatMessage(userData._id);
      getConversations(userData._id);
    })();
    userData.role === staticConstants.ROLE.MANAGER && activeArtistQuery();
    return () => {
    };
  },
  []);

  useEffect(() => {
    userData.role === staticConstants.ROLE.MANAGER && activeArtistData && (() => {
      onNewChatMessage(activeArtistData.activeArtist._id);
      getConversations(activeArtistData.activeArtist._id);
    })();
  },
  [activeArtistData]);

  return {
    onNewMessage: onNewChatMessage, getConversations, getMessages, markConversationAsRead,
  };
};
